import { render, staticRenderFns } from "./PageDown.vue?vue&type=template&id=1755c085&scoped=true"
import script from "./PageDown.vue?vue&type=script&lang=js"
export * from "./PageDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1755c085",
  null
  
)

export default component.exports